import React, {useState, useEffect} from "react"
import {useSelector} from "react-redux"

import Input from "../LeftWorkText/Input"

import "./leftworkeditimage.scss"

const initForm = {
  scale: 100,
  rotation: 0,
}

/**
 * Form for edit image
 * @component
 * @example
 * return (
 *  <FormEdit />
 * )
 */

const FormEdit = () => {
  const [formState, setFormState] = useState(initForm)

  const [rand, setRand] = useState(1)
  /**
   * api instnts from redux
   */
  const makFabric = useSelector(state => state.makFabric)
  /**
   * selected obj from redux
   */
  const activeObj = useSelector(state => state.activeObj)

  /**
   * Change image scale
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const handleChange = ({target}) => {
    setFormState(prev => ({
      ...prev,
      [target.name]: target.value.replace(/[^+\d]/g, ""),
    }))

    makFabric.scaleObject(activeObj, target.value.replace(/[^+\d]/g, ""))
  }

  /**
   * Change image rotation
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const changeRotation = ({target}) => {
    setFormState(prev => ({
      ...prev,
      rotation: target.value.replace(/[^+\d]/g, ""),
    }))

    makFabric.rotateObject(activeObj, target.value.replace(/[^+\d]/g, ""))
  }

  const handleRotation = e => {
    e.preventDefault()
    e.target.name === "plus" &&
      setFormState(prev => ({
        ...prev,
        rotation: prev.rotation + 1,
      }))
    e.target.name === "minus" &&
      setFormState(prev => ({
        ...prev,
        rotation: prev.rotation - 1,
      }))
  }

  // const handleRepeat = e => {
  //   e.preventDefault()
  //   makFabric.repeatObject(activeObj)
  // }

  useEffect(() => {
    if (makFabric) {
      makFabric.help.selectedObj = () => setRand(Math.random() * 100)
    }
    return () => (makFabric.help.selectedObj = () => {})
  }, [makFabric])

  //   =====================Get State from canvas
  useEffect(() => {
    if (rand && makFabric && activeObj && activeObj.type === "image") {
      setFormState(prev => ({
        ...prev,
        scale: Math.round(activeObj.scaleX * 100),
        rotation: Math.round(activeObj.angle),
      }))
    }
  }, [makFabric, activeObj, rand])

  useEffect(() => {
    if (activeObj && (formState.rotation || formState.rotation === 0)) {
      makFabric.rotateObject(activeObj, formState.rotation)
    }
  }, [activeObj, formState.rotation, makFabric])

  return (
    <div className="leftWorkEditImageForm">
      <div className="leftWorkEditImageInpt_container">
        <span className="leftWorkEditImageInpt_title">Scale</span>
        <div>
          <input
            className="leftWorkEditImageInpt"
            type="text"
            value={formState.scale}
            name="scale"
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="leftWorkEditImageInpt_container">
        <span className="leftWorkEditImageInpt_title">Rotation</span>
        <div>
          <Input
            value={formState.rotation}
            name="rotation"
            handler={handleRotation}
            changes={changeRotation}
          />
        </div>
      </div>
    </div>
  )
}

export default FormEdit

// <div>
// <button onClick={handleRepeat} className={styles.btn}>
//   {" "}
//   Repeat
// </button>
// </div>
